import { FC } from 'react';
import Loupe from 'assets/images/loupe_icon.png';
import LoupeSelected from 'assets/images/loupe_selected_icon.png';

const LoupeIcon: FC<{ isSelected: boolean }> = ({ isSelected }) => {
  return (
    <>
      {isSelected ? (
        <img src={LoupeSelected} alt="loupeIcon" />
      ) : (
        <img src={Loupe} alt="loupeIcon" />
      )}
    </>
  );
};

export default LoupeIcon;
